import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-spinner',
    imports: [],
    templateUrl: './spinner.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
  @Input() message = '';

}
